import { BuyerActivitySummaryState } from './BuyerActivitySummaryTypes';

export const BuyerActivitySummaryActionTypes = {
  LOADING_BUYER_ACTIVITY: 'loadingBuyerActivity',

  LOAD_BUYER_ACTIVITY: 'loadBuyerActivity',
  LOADED_BUYER_ACTIVITY: 'loadedBuyerActivity',
  LOAD_BUYER_ACTIVITY_ERROR: 'loadBuyerActivityError',

  LOAD_BUYER_ACTIVITY_SPLIT_SCENARIOS: 'loadBuyerActivitySplitScenarios',
  LOADED_BUYER_ACTIVITY_SPLIT_SCENARIOS: 'loadedBuyerActivitySplitScenarios',
  LOAD_BUYER_ACTIVITY_SPLIT_SCENARIOS_ERROR: 'loadBuyerActivitySplitScenariosError',

  SELECT_SPLIT_SCENARIOS: 'selectSplitScenarios',
};

export const DEFAULT_STATE: BuyerActivitySummaryState = {
  splitScenarios: [],
  buyerActivitySummary: [],
  reloadBuyerActivity: false,
  reloadSplitScenarios: false,
  selectedOption: [],
};
